import { useParams, useLocation } from 'react-router-dom'
import VehicleMakeLandingPageTemplate from '@/components/shared/VehicleMakeLandingPageTemplate'

const VehiclePage = () => {
  const { make } = useParams()
  const location = useLocation().pathname

  // Handle specific route cases
  let vehicleMake
  let slug
  if (location === '/vehicles/audi-car-finance') {
    vehicleMake = 'Audi'
    slug = '/vehicles/audi-car-finance'
  } else if (make) {
    vehicleMake = make.charAt(0).toUpperCase() + make.slice(1)
    slug = `/vehicles/${make}`
  } else {
    vehicleMake = 'Vehicle'
    slug = '/vehicles'
  }

  return (
    <VehicleMakeLandingPageTemplate
      vehicleMake={vehicleMake}
      slug={slug}
      seoImage="/Image/Car-photo-illustration-claims1.webp"
      seoImageAlt={`${vehicleMake} car finance claims`}
    />
  )
}

export default VehiclePage
